import { render, staticRenderFns } from "./EditWaitAction.vue?vue&type=template&id=ea42c4f6&"
import script from "./EditWaitAction.vue?vue&type=script&lang=js&"
export * from "./EditWaitAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports